import "./index.scss";

import React from "react";
import { connect } from "react-redux";


@connect(store => {
    return {
        project: store.project
    };
})

class Proceed extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null
        }

        _.map([ "onClearHistory", "onProceed" ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }
    
    onClearHistory() {
        const { history } = this.props;

        history.push({...history.location, search: null});
    }

    onProceed() {
        const { project } = this.props;
        window.location.replace(`/account#/projects/${ project.Selected.id}/settings?proceed=true`);
    }

    render() {
        const { project } = this.props
        return (
            <div class="modal fade bg-overlay add-modal proceed-modal" data-backdrop="static" data-keyboard="false" id="proceedToDetailsModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bb">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="modalTitle">{project.Type === "company" ? "Company" : "Project" } successfully created!</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            <p>Continue setting up account details?</p>
                        </div>
                        <div class="modal-footer">
                            <div class="modalActions">
                                <button type="button" class={`btn btn-secondary btn-skip `} onClick={this.onClearHistory} data-dismiss="modal" >Skip</button>
                                <button type="button" class={`btn btn-create`} onClick={this.onProceed} data-dismiss="modal">Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Proceed;
